import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import axios from 'axios';
let CancelToken = axios.CancelToken;
let fetchSupportFiles_cancel;
let checkDeleteSupportFiles_cancel;

export const fetchSupportFilesSuccess = (supportFiles) => {
  return {
    type: actionTypes.FETCH_SUPPORT_FILES_SUCCESS,
    supportFiles: supportFiles
  };
};

export const requestSupportFilesFail = (error) => {
  return {
    type: actionTypes.REQUEST_SUPPORT_FILES_FAIL,
    error: error
  };
};

export const requestSupportFilesStart = () => {
  return {
    type: actionTypes.REQUEST_SUPPORT_FILES_START
  };
};

export const deleteSupportFilesSuccess = (area) => {
  return {
    type: actionTypes.DELETE_SUPPORT_FILES_SUCCESS,
    area: area
  }
}

export const updateSupportFilesSuccess = (area) => {
  return {
    type: actionTypes.UPDATE_SUPPORT_FILES_SUCCESS,
    area: area
  }
}

export const postSupportFilesSuccess = (area) => {
  return {
    type: actionTypes.POST_SUPPORT_FILES_SUCCESS,
    area: area
  }
}

export const fetchSupportFiles = (page, limit, search, order, orderBy, visibility) => {
  fetchSupportFiles_cancel && fetchSupportFiles_cancel()
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestSupportFilesStart());
      const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&sort=${order === 'desc' ? '-' : ''}${orderBy}&fields=${visibility}`;
      API.get('/supportfiles' + queryParams, {
        cancelToken: new CancelToken(function executor(c) {
          fetchSupportFiles_cancel = c;
        })
      })
        .then(res => {
          dispatch(fetchSupportFilesSuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestSupportFilesFail(err));
          reject(err);
        });
    });
  }
};

export const deleteSupportFiles = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestSupportFilesStart());
      API.put('/supportfiles/delete/' + index)
        .then(res => {
          dispatch(deleteSupportFilesSuccess(res.data));
          toastr.success('Arquivo de apoio deletado', `${res.data.description} deletado com sucesso`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestSupportFilesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

export const postSupportFiles = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestSupportFilesStart());
      API.post('/supportfiles', body)
        .then(res => {
          dispatch(postSupportFilesSuccess(res.data));
          toastr.success('Arquivo de apoio adicionado', `Os arquivos de ${res.data.description} foram adicionados com sucesso`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestSupportFilesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error('Arquivo de apoio já cadastrado', 'Insira outro nome')
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updateSupportFiles = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestSupportFilesStart());
      API.put('/supportfiles/' + index, body)
        .then(res => {
          dispatch(updateSupportFilesSuccess(res.data));
          toastr.success('Arquivo de apoio atualizado', `${res.data.description} foi atualizado com sucesso`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestSupportFilesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error('Arquivo de apoio já cadastrado', 'Insira outro nome')
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}